import { Box, VStack } from '@chakra-ui/react';
import React from 'react';
import Searching from './components/Searching/Searching';
import Filtering from './components/Searching/Filtering';
import Calender from './components/Searching/Calender';
import Educators from './components/Searching/educators';
import Header from '../../components/layouts/Header/Header';
import HeaderGap from '../../components/layouts/Header/HeaderGap';
import './live.component.css'
const Live = () => {
    return (
        <div>
            <Header/>
            <HeaderGap/>
                <VStack bg={"rgba(245, 245, 255, 1)"}>
                <Box w="80%" mx="auto" className='live-area'>
                    <Searching/>
                    <Filtering/>
                    <Calender/>
                    <Educators/>
                </Box>
            </VStack>
        
        </div>

    );
};

export default Live;